import axios from "axios";
import { Report } from "notiflix";

const clientAxios = axios.create({
    baseURL: process.env.REACT_APP_BACK_URL,
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: true
});

// Latch para no disparar la alerta varias veces cuando varias requests
// fallan con 401 al mismo tiempo (típico al cargar el dashboard, donde
// pueden salir 5+ peticiones en paralelo). Se desbloquea con la
// recarga de la página.
let sessionExpiredAlertShown = false;

const handleSessionExpired = () => {
    localStorage.removeItem('AUTH_TOKEN');
    sessionStorage.removeItem('AUTH_TOKEN');

    if (sessionExpiredAlertShown) return;
    sessionExpiredAlertShown = true;

    Report.warning(
        'Sesión expirada',
        'Tu sesión ha caducado. Por favor inicia sesión nuevamente.',
        'Aceptar',
        () => {
            // El redirect lo hacemos al cerrar el reporte para que el
            // usuario alcance a leer el mensaje. Si ya está en home no
            // hace falta navegar (evita un reload innecesario).
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
        },
        { backOverlayColor: 'rgba(0,0,0,0.5)' }
    );
};

// Interceptor 401: cuando el token expira en el back (Sanctum), limpia
// almacenamiento y avisa al usuario antes de redirigir. Solo actúa si
// había un token guardado, para no interferir con login fallido por
// credenciales (ese 401 lo maneja el formulario con su propio mensaje).
clientAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const storedToken =
                localStorage.getItem('AUTH_TOKEN') ||
                sessionStorage.getItem('AUTH_TOKEN');

            if (storedToken) {
                handleSessionExpired();
            }
        }
        return Promise.reject(error);
    }
);

export default clientAxios;
